module.exports = __webpack_public_path__ + "static/media/question.f09b3c3b.svg";